import { z } from 'zod';

const PartsCategoriesFileSchema = z.custom<File>(
  (data: unknown) => {
    if (data == null || !(data instanceof File) || !data.name.endsWith('.csv') || data.size < 1) {
      return false;
    }
    return data;
  },
  (input: unknown) => {
    if (input == null) {
      return { message: 'Parts Categories file is required' };
    }

    if (input instanceof File) {
      if (!input.name.endsWith('.csv')) {
        return { message: 'Please upload your Parts Categories in CSV format' };
      }

      if (input.size < 1) {
        return { message: 'Parts Categories file must not be empty' };
      }
    }

    return { message: 'Parts Categories file is required' };
  }
);

export const partsCategoriesFormSchema = z.object({
  file: PartsCategoriesFileSchema,
});

export type PartsCategoriesFormSchema = z.infer<typeof partsCategoriesFormSchema>;
